import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../lib/apiContext';
import { queryKeys } from '../../lib/queryKeys';
import type { FleetResponse } from '../../lib/types';

/** GET /fleet — the cached fleet listing. */
export function useFleet() {
  const client = useApiClient();
  return useQuery({
    queryKey: queryKeys.fleet,
    queryFn: () => client.get<FleetResponse>('/fleet'),
  });
}
